import Localization from '~/client/src/shared/localization/LocalizationManager'
import { isPhoneNumberValid } from '~/client/src/shared/utils/phoneNumberValidation'
import { VALID_EMAIL_PATTERN } from '~/client/src/shared/utils/regExpPatterns'

export function getEmailError(value: string, isRequired = true): string {
  const { authFieldErrors } = Localization.translator
  const email = value.trim()

  if (!email) {
    return isRequired ? authFieldErrors.enterYourEmail : ''
  }
  return VALID_EMAIL_PATTERN.test(email) ? '' : authFieldErrors.enterValidEmail
}

export function getPhoneNumberError(value: string): string {
  const { authFieldErrors } = Localization.translator

  if (!value) {
    return authFieldErrors.enterYourPhoneNumber
  }
  return isPhoneNumberValid(value) ? '' : authFieldErrors.enterValidPhoneNumber
}
